const THREE = require("three");
export function retarget(p7599, p7600, p7601 = {}) {
  const v6320 = new THREE.Vector3();
  const v6321 = new THREE.Quaternion();
  const v6322 = new THREE.Vector3();
  const v6323 = new THREE.Matrix4();
  const v6324 = new THREE.Matrix4();
  const v6325 = new THREE.Matrix4();
  p7601.preserveMatrix = p7601.preserveMatrix !== undefined ? p7601.preserveMatrix : true;
  p7601.preservePosition = p7601.preservePosition !== undefined ? p7601.preservePosition : true;
  p7601.preserveHipPosition = p7601.preserveHipPosition !== undefined ? p7601.preserveHipPosition : false;
  p7601.useTargetMatrix = p7601.useTargetMatrix !== undefined ? p7601.useTargetMatrix : false;
  p7601.hip = p7601.hip !== undefined ? p7601.hip : "hip";
  p7601.names = p7601.names || {};
  const v6326 = p7600.isObject3D ? p7600.skeleton.bones : getBones(p7600);
  const v6327 = p7599.isObject3D ? p7599.skeleton.bones : getBones(p7599);
  let v6328;
  let v6329;
  let v6330;
  let v6331;
  let v6332;
  if (p7599.isObject3D) {
    p7599.skeleton.pose();
  } else {
    p7601.useTargetMatrix = true;
    p7601.preserveMatrix = false;
  }
  if (p7601.preservePosition) {
    v6332 = [];
    for (let vLN01010 = 0; vLN01010 < v6327.length; vLN01010++) {
      v6332.push(v6327[vLN01010].position.clone());
    }
  }
  if (p7601.preserveMatrix) {
    p7599.updateMatrixWorld();
    p7599.matrixWorld.identity();
    for (let vLN01011 = 0; vLN01011 < p7599.children.length; ++vLN01011) {
      p7599.children[vLN01011].updateMatrixWorld(true);
    }
  }
  if (p7601.offsets) {
    v6328 = [];
    for (let vLN01012 = 0; vLN01012 < v6327.length; ++vLN01012) {
      v6329 = v6327[vLN01012];
      v6330 = p7601.names[v6329.name] || v6329.name;
      if (p7601.offsets[v6330]) {
        v6329.matrix.multiply(p7601.offsets[v6330]);
        v6329.matrix.decompose(v6329.position, v6329.quaternion, v6329.scale);
        v6329.updateMatrixWorld();
      }
      v6328.push(v6329.matrixWorld.clone());
    }
  }
  for (let vLN01013 = 0; vLN01013 < v6327.length; ++vLN01013) {
    v6329 = v6327[vLN01013];
    v6330 = p7601.names[v6329.name] || v6329.name;
    v6331 = getBoneByName(v6330, v6326);
    v6325.copy(v6329.matrixWorld);
    if (v6331) {
      v6331.updateMatrixWorld();
      if (p7601.useTargetMatrix) {
        v6324.copy(v6331.matrixWorld);
      } else {
        v6324.copy(p7599.matrixWorld).invert();
        v6324.multiply(v6331.matrixWorld);
      }
      v6322.setFromMatrixScale(v6324);
      v6324.scale(v6322.set(1 / v6322.x, 1 / v6322.y, 1 / v6322.z));
      v6325.makeRotationFromQuaternion(v6321.setFromRotationMatrix(v6324));
      if (p7599.isObject3D) {
        const v6333 = v6327.indexOf(v6329);
        const v6334 = v6328 ? v6328[v6333] : v6323.copy(p7599.skeleton.boneInverses[v6333]).invert();
        v6325.multiply(v6334);
      }
      v6325.copyPosition(v6324);
    }
    if (v6329.parent && v6329.parent.isBone) {
      v6329.matrix.copy(v6329.parent.matrixWorld).invert();
      v6329.matrix.multiply(v6325);
    } else {
      v6329.matrix.copy(v6325);
    }
    if (p7601.preserveHipPosition && v6330 === p7601.hip) {
      v6329.matrix.setPosition(v6320.set(0, v6329.position.y, 0));
    }
    v6329.matrix.decompose(v6329.position, v6329.quaternion, v6329.scale);
    v6329.updateMatrixWorld();
  }
  if (p7601.preservePosition) {
    for (let vLN01014 = 0; vLN01014 < v6327.length; ++vLN01014) {
      v6329 = v6327[vLN01014];
      v6330 = p7601.names[v6329.name] || v6329.name;
      if (v6330 !== p7601.hip) {
        v6329.position.copy(v6332[vLN01014]);
      }
    }
  }
  if (p7601.preserveMatrix) {
    p7599.updateMatrixWorld(true);
  }
}
export function retargetClip(p7602, p7603, p7604, p7605 = {}) {
  p7605.useFirstFramePosition = p7605.useFirstFramePosition !== undefined ? p7605.useFirstFramePosition : false;
  p7605.fps = p7605.fps !== undefined ? p7605.fps : 30;
  p7605.names = p7605.names || [];
  if (!p7603.isObject3D) {
    p7603 = getHelperFromSkeleton(p7603);
  }
  const v6335 = Math.round(p7604.duration * (p7605.fps / 1000) * 1000);
  const v6336 = 1 / p7605.fps;
  const vA344 = [];
  const v6337 = new THREE.AnimationMixer(p7603);
  const vIi28 = getBones(p7602.skeleton);
  const vA345 = [];
  let v6338;
  let v6339;
  let v6340;
  let v6341;
  let v6342;
  v6337.clipAction(p7604).play();
  v6337.update(0);
  p7603.updateMatrixWorld();
  for (let vLN01015 = 0; vLN01015 < v6335; ++vLN01015) {
    const v6343 = vLN01015 * v6336;
    retarget(p7602, p7603, p7605);
    for (let vLN01016 = 0; vLN01016 < vIi28.length; ++vLN01016) {
      v6342 = p7605.names[vIi28[vLN01016].name] || vIi28[vLN01016].name;
      v6340 = getBoneByName(v6342, p7603.skeleton);
      if (v6340) {
        v6339 = vIi28[vLN01016];
        v6341 = vA345[vLN01016] = vA345[vLN01016] || {
          bone: v6339
        };
        if (p7605.hip === v6342) {
          if (!v6341.pos) {
            v6341.pos = {
              times: new Float32Array(v6335),
              values: new Float32Array(v6335 * 3)
            };
          }
          if (p7605.useFirstFramePosition) {
            if (vLN01015 === 0) {
              v6338 = v6339.position.clone();
            }
            v6339.position.sub(v6338);
          }
          v6341.pos.times[vLN01015] = v6343;
          v6339.position.toArray(v6341.pos.values, vLN01015 * 3);
        }
        if (!v6341.quat) {
          v6341.quat = {
            times: new Float32Array(v6335),
            values: new Float32Array(v6335 * 4)
          };
        }
        v6341.quat.times[vLN01015] = v6343;
        v6339.quaternion.toArray(v6341.quat.values, vLN01015 * 4);
      }
    }
    v6337.update(v6336);
    p7603.updateMatrixWorld();
  }
  for (let vLN01017 = 0; vLN01017 < vA345.length; ++vLN01017) {
    v6341 = vA345[vLN01017];
    if (v6341) {
      if (v6341.pos) {
        vA344.push(new THREE.VectorKeyframeTrack(".bones[" + v6341.bone.name + "].position", v6341.pos.times, v6341.pos.values));
      }
      vA344.push(new THREE.QuaternionKeyframeTrack(".bones[" + v6341.bone.name + "].quaternion", v6341.quat.times, v6341.quat.values));
    }
  }
  v6337.uncacheAction(p7604);
  return new THREE.AnimationClip(p7604.name, -1, vA344);
}
export function getHelperFromSkeleton(p7606) {
  const v6344 = new THREE.SkeletonHelper(p7606.bones[0]);
  v6344.skeleton = p7606;
  return v6344;
}
export function getSkeletonOffsets(p7607, p7608, p7609 = {}) {
  const v6345 = new THREE.Vector3();
  const v6346 = new THREE.Vector3();
  const v6347 = new THREE.Vector3();
  const v6348 = new THREE.Vector3();
  const v6349 = new THREE.Vector2();
  const v6350 = new THREE.Vector2();
  p7609.hip = p7609.hip !== undefined ? p7609.hip : "hip";
  p7609.names = p7609.names || {};
  if (!p7608.isObject3D) {
    p7608 = getHelperFromSkeleton(p7608);
  }
  const v6351 = Object.keys(p7609.names);
  const v6352 = Object.values(p7609.names);
  const v6353 = p7608.isObject3D ? p7608.skeleton.bones : getBones(p7608);
  const v6354 = p7607.isObject3D ? p7607.skeleton.bones : getBones(p7607);
  const vA346 = [];
  let v6355;
  let v6356;
  let v6357;
  let v6358;
  p7607.skeleton.pose();
  for (v6358 = 0; v6358 < v6354.length; ++v6358) {
    v6355 = v6354[v6358];
    v6357 = p7609.names[v6355.name] || v6355.name;
    v6356 = getBoneByName(v6357, v6353);
    if (v6356 && v6357 !== p7609.hip) {
      const vIi29 = getNearestBone(v6355.parent, v6351);
      const vIi30 = getNearestBone(v6356.parent, v6352);
      vIi29.updateMatrixWorld();
      vIi30.updateMatrixWorld();
      v6345.setFromMatrixPosition(vIi29.matrixWorld);
      v6346.setFromMatrixPosition(v6355.matrixWorld);
      v6347.setFromMatrixPosition(vIi30.matrixWorld);
      v6348.setFromMatrixPosition(v6356.matrixWorld);
      v6349.subVectors(new THREE.Vector2(v6346.x, v6346.y), new THREE.Vector2(v6345.x, v6345.y)).normalize();
      v6350.subVectors(new THREE.Vector2(v6348.x, v6348.y), new THREE.Vector2(v6347.x, v6347.y)).normalize();
      const v6359 = v6349.angle() - v6350.angle();
      const v6360 = new THREE.Matrix4().makeRotationFromEuler(new THREE.Euler(0, 0, v6359));
      v6355.matrix.multiply(v6360);
      v6355.matrix.decompose(v6355.position, v6355.quaternion, v6355.scale);
      v6355.updateMatrixWorld();
      vA346[v6357] = v6360;
    }
  }
  return vA346;
}
export function renameBones(p7610, p7611) {
  const vIi31 = getBones(p7610);
  for (let vLN01018 = 0; vLN01018 < vIi31.length; ++vLN01018) {
    const v6361 = vIi31[vLN01018];
    if (p7611[v6361.name]) {
      v6361.name = p7611[v6361.name];
    }
  }
  return this;
}
export function getBones(p7612) {
  if (Array.isArray(p7612)) {
    return p7612;
  } else {
    return p7612.bones;
  }
}
export function getBoneByName(p7613, p7614) {
  for (let vLN01019 = 0, vF1123 = getBones(p7614); vLN01019 < vF1123.length; vLN01019++) {
    if (p7613 === vF1123[vLN01019].name) {
      return vF1123[vLN01019];
    }
  }
}
export function getNearestBone(p7615, p7616) {
  while (p7615.isBone) {
    if (p7616.indexOf(p7615.name) !== -1) {
      return p7615;
    }
    p7615 = p7615.parent;
  }
}
export function findBoneTrackData(p7617, p7618) {
  const v6362 = /\[(.*)\]\.(.*)/;
  const vO183 = {
    name: p7617
  };
  for (let vLN01020 = 0; vLN01020 < p7618.length; ++vLN01020) {
    const v6363 = v6362.exec(p7618[vLN01020].name);
    if (v6363 && p7617 === v6363[1]) {
      vO183[v6363[2]] = vLN01020;
    }
  }
  return vO183;
}
export function getEqualsBonesNames(p7619, p7620) {
  const vF11232 = getBones(p7619);
  const vF11233 = getBones(p7620);
  const vA347 = [];
  iÌîiìïi: for (let vLN01021 = 0; vLN01021 < vF11232.length; vLN01021++) {
    const v6364 = vF11232[vLN01021].name;
    for (let vLN01022 = 0; vLN01022 < vF11233.length; vLN01022++) {
      if (v6364 === vF11233[vLN01022].name) {
        vA347.push(v6364);
        continue iÌîiìïi;
      }
    }
  }
  return vA347;
}
export function clone(p7621) {
  const v6365 = new Map();
  const v6366 = new Map();
  const v6367 = p7621.clone();
  f1129(p7621, v6367, function (p7622, p7623) {
    v6365.set(p7623, p7622);
    v6366.set(p7622, p7623);
  });
  v6367.traverse(function (p7624) {
    if (!p7624.isSkinnedMesh) {
      return;
    }
    const vP7624 = p7624;
    const v6368 = v6365.get(p7624);
    const v6369 = v6368.skeleton.bones;
    vP7624.skeleton = v6368.skeleton.clone();
    vP7624.bindMatrix.copy(v6368.bindMatrix);
    vP7624.skeleton.bones = v6369.map(function (p7625) {
      return v6366.get(p7625);
    });
    vP7624.bind(vP7624.skeleton, vP7624.bindMatrix);
  });
  return v6367;
}
function f1129(p7626, p7627, p7628) {
  p7628(p7626, p7627);
  for (let vLN01023 = 0; vLN01023 < p7626.children.length; vLN01023++) {
    f1129(p7626.children[vLN01023], p7627.children[vLN01023], p7628);
  }
}